import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  selectContainer: {
    overflowX: 'hidden',
    overflowY: 'scroll',
    maxHeight: '400px',
  },
  iconButton: {
    width: '5px',
    height: '5px',
    padding: '8px',
    paddingLeft: '10px',
  },
}));

export default useStyles;
